import { useEffect, useRef } from 'react';
import { BackKeyInterceptor, useBackKeyInterceptorStore } from '../stores/backKeyInterceptorStore';

/**
 * 백키 인터셉터 hook 옵션
 */
interface UseBackKeyInterceptorOptions {
    enabled?: boolean;
    type?: 'page' | 'popup';
}

/**
 * 물리 백 버튼 인터셉터 hook
 */
export const useBackKeyInterceptor = (
    options: UseBackKeyInterceptorOptions,
    interceptor: BackKeyInterceptor,
) => {
    const interceptorRef = useRef<BackKeyInterceptor>(interceptor);
    const { register, unregister } = useBackKeyInterceptorStore();
    const { enabled = false } = options;

    interceptorRef.current = interceptor;

    //hdg : interceptor 초기화 -  래핑추가
    const wrappedInterceptor = useRef<BackKeyInterceptor | null>(null);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        //hdg : interceptor 초기화 -  래핑추가
        const backKeyInterceptor: BackKeyInterceptor = () => interceptorRef.current();
        wrappedInterceptor.current = backKeyInterceptor;

        console.log('# useBackKeyInterceptor register(wrappedInterceptor)');

        register({ interceptor: backKeyInterceptor, type: options.type ?? 'page' });

        return () => {
            console.log('# useBackKeyInterceptor unregister(wrappedInterceptor)');
            unregister(backKeyInterceptor);

            //hdg : interceptor 초기화 -  래핑추가
            wrappedInterceptor.current = null;
        };
    }, [enabled]);
};
